export const SET_AUCTION_ITEM = 'SET AUCTION ITEM'
export const SET_SERVER_TIME = 'SET SERVER TIME'